/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';

export const GET_REJECTED_APPLICATIONS = gql`
  query GetListOfApplication($input: GetAppListInput) {
    getListOfApplication(input: $input) {
      currentPage
      pageSize
      totalCount
      totalPages
      data {
        createdAt
        updatedAt
        applicant
        applicantInfo {
          vuid
          userId
          email
          firstName
          middleName
          lastName
          fullName
          emailVerified
          phoneVerified
          image
          accountStatus
          bannerImg
          address {
            addressLine1
            addressLine2
            addressLine3
            city
            state
            zipcode
            country
            parish
          }
          occupation
          bio
          primaryContactNo
          nationality

          createdAt
          alias
          childrenOrDependent
          gender
          maritalStatus
          passportExpiry
          passportNumber
          passportType
          placeOfBirth
          qualification {
            institute
            from
            to
            degree
            description
          }
          skills
          trn
          dateOfBirth
          declaration {
            selected
            value
          }
          lastEmployer {
            address {
              addressLine1
              addressLine2
              addressLine3
              city
              country
              parish
              state
              zipcode
            }
            country
            dateOfRegistration
            declaration {
              selected
              value
            }
            description
            email
            fax
            incorporationDate
            isSubsidiary
            logo
            name
            natureOfBusiness
            operatingAddress {
              addressLine1
              addressLine2
              addressLine3
              city
              country
              parish
              state
              zipcode
            }
            orgId
            primaryContactNo
            registrationNo
            socialLinks
            status
            tradingName
            trn
            type
            website
            workPermitIsInRelationTo
            credentialNo
            wpExpiry
          }
          permissionPeriod {
            from
            to
          }
          spouseName
          spouseNationality
          spouseLastEmployer {
            address {
              addressLine1
              addressLine2
              addressLine3
              city
              country
              parish
              state
              zipcode
            }
            country
            dateOfRegistration
            declaration {
              selected
              value
            }
            description
            email
            fax
            incorporationDate
            isSubsidiary
            name
            natureOfBusiness
            operatingAddress {
              addressLine1
              addressLine2
              addressLine3
              city
              country
              parish
              state
              zipcode
            }
            primaryContactNo
            registrationNo
            status
            tradingName
            trn
            type
            website
            workPermitIsInRelationTo
            credentialNo
            wpExpiry
          }
          countryConvicted
          criminalOffence
          dateOfConviction
          natureOfOffence
          workedInJamaica
          workExperience {
            from
            to
            jobDuty
            nameOfOrganization
            refLetter
          }
          dependentInfo {
            dependentType
            name
            passportNumber
            relationship
            age
            documents {
              expiry
              fileType
              name
              src
              type
            }
            gender
            nationality
          }
          isLastNameExist
        }
        applicationNo
        appliedBy
        comment
        documents {
          name
          type
          src
          fileType
          expiry
        }
        employerInfo {
          orgId
          name
          tradingName
          description
          email
          registrationNo
          trn
          incorporationDate
          type
          dateOfRegistration
          fax
          operatingAddress {
            addressLine1
            addressLine2
            addressLine3
            city
            state
            zipcode
            country
            parish
          }
          natureOfBusiness
          website
          primaryContactNo
          address {
            addressLine1
            addressLine2
            addressLine3
            city
            state
            zipcode
            country
            parish
          }
          logo
          country
          status
          isSubsidiary
          workPermitIsInRelationTo
          saffCompsition {
            citizenship
            professional
            clerksOrServiceWorker
            skilledWorkers
            plantAndMachineOperators
            elementaryOccupations
            total
          }
          credentialNo
          wpExpiry
          tccExpiryDate
          tccNumber
        }
        jobInfo {
          JobTitle
          description
          necessaryQualification
          salaryOffered
          allowances {
            house
            car
            entertainment
            other
          }
          currency
          stepsForJaimacan {
            internalRecruitment

            didJamaicanApply
            appliedCandidates
            noStepTaken
            reasonNoneHired
            byAdvertisement
          }
          JobId
          benefitsReceived
          jobDuties
          registeredLMIS
          workingHours
        }
        status
        type
      }
    }
  }
`;
